export default __webpack_public_path__ + "static/media/Water_Bath.29698859.svg";